export default function SubProductCard({
  product, sub_product, onSelect,
}) {
  return (
    <div className="col-9 col-md-6 col-lg-5 col-xl-3">
      <div className="product cursor-pointer d-flex align-items-center justify-content-center flex-column gap-2" onClick={onSelect} style={{ height: '100px' }}>
        <label className="h5 m-0">{product}</label>
        {sub_product && <small className="h6">{sub_product}</small>}
      </div>
    </div>
  );
}
